const actions = {
  GET_INVOICE: 'GET_INVOICE',
  // Sin esta acción, cuando el backend responde success:false (o la petición
  // revienta), `loadingInvoices` se quedaba en true PARA SIEMPRE. Y como
  // Invoices.js hace `if (loadingInvoices) return;` antes de disparar una
  // búsqueda, la pantalla quedaba congelada: ninguna búsqueda posterior salía
  // hasta recargar el navegador.
  GET_INVOICE_ERROR: 'GET_INVOICE_ERROR',
  UPDATE_INVOICE: 'UPDATE_INVOICE',
  UPDATE_INVOICE_SAGA: 'UPDATE_INVOICE_SAGA',
  SELECT_CURRENT_INVOICE: 'SELECT_CURRENT_INVOICE',
  TOGGLE_VIEW: 'INVOICE_TOGGLE_VIEW',
  UPDATE_EDIT_INVOICE: 'INVOICE_UPDATE_EDIT_INVOICE',
  SET_CURRENT_INVOICE: 'SET_CURRENT_INVOICE',
  DELETE_INVOICE: 'DELETE_INVOICE',
  DELETE_HARD_INVOICE: 'DELETE_HARD_INVOICE',
  SAVE_INVOICE: 'SAVE_INVOICE',
  INVOICE_USER:'INVOICE_USER',

  // DIAN
  DIAN_PREPARAR:         'DIAN_PREPARAR',
  DIAN_PREPARAR_SUCCESS: 'DIAN_PREPARAR_SUCCESS',
  DIAN_PREPARAR_ERROR:   'DIAN_PREPARAR_ERROR',
  SET_DIAN_LOADING:      'SET_DIAN_LOADING',

  PASS_PEDIDOS_TO_INVOICES: 'PASS_PEDIDOS_TO_INVOICES',
  SET_PAGINATION_INFO: 'SET_PAGINATION_INFO',
  initData: query  => ({ type: actions.GET_INVOICE, query }),
  deleteInvoice: (id, motivo) => ({ type: actions.DELETE_INVOICE, id, motivo }),
  deleteHardInvoice: id => ({ type: actions.DELETE_HARD_INVOICE, id }),
  prepararDIAN: (facturaIds) => ({ type: actions.DIAN_PREPARAR, facturaIds }),
  updateInvoice: invoice => {
    return (dispatch, getState) => {
      const invoices = getState().Invoices.invoices;
      const index = invoices.map(inv => inv.id).indexOf(invoice.id);
      if (index === -1) {
        invoices.push(invoice);
      } else {
        invoices[index] = invoice;
      }
      dispatch({
        type: actions.UPDATE_INVOICE_SAGA,
        invoices,
        invoice,
      });
    };
  },
  selectCurrentInvoice: id => ({ type: actions.SELECT_CURRENT_INVOICE, id }),
  toggleView: view => ({ type: actions.TOGGLE_VIEW, view }),
  editInvoice: invoice => ({ type: actions.UPDATE_EDIT_INVOICE, invoice }),
  saveInvoice: (invoice, history) => ({ type: actions.SAVE_INVOICE, invoice, history }),
  
  passPedidosToInvoices: pedidos => ({type: actions.PASS_PEDIDOS_TO_INVOICES, payload: pedidos })
};
export default actions;
